/* Navigace 2026: panely v hlavním menu (najetí myší se záměrem, kliknutí připne,
   klávesnice, Esc, klik mimo), šířka pásu, tlačítko v šuplíku a měření kliknutí. */
(() => {
  const DESK = matchMedia('(min-width: 1190px)');
  const HOVER = matchMedia('(hover: hover) and (pointer: fine) and (min-width: 1190px)');
  const RM = matchMedia('(prefers-reduced-motion: reduce)');
  const root = document.documentElement;
  let nav = null, all = [], tOpen, tClose;
  /* Poslední poloha ukazatele (lx, ly) a bod, od kterého se měří klid (ax, ay). */
  let lx = 0, ly = 0, ax = -99, ay = -99;
  /* Cesta k pásu: kde ukazatel opustil položku (x, y), spodek položky (b), horní okraj pásu (t). */
  let aim = null;

  const setVw = () => root.style.setProperty('--dmp-vw', root.clientWidth + 'px');
  const sync = (d) => d.firstElementChild.setAttribute('aria-expanded', d.open && !d.classList.contains('dmp-closing') ? 'true' : 'false');
  const current = () => all.find((d) => d.open && !d.classList.contains('dmp-closing'));

  function eager() {
    if (!nav || nav.dataset.dmpEager) return;
    nav.dataset.dmpEager = '1';
    /* Fotky nemají v HTML src, aby je prohlížeč nestáhl dřív (ani z mezipaměti). */
    nav.querySelectorAll('img[data-src]').forEach((i) => {
      i.loading = 'eager';
      i.srcset = i.dataset.srcset;
      i.src = i.dataset.src;
      i.removeAttribute('data-src');
    });
    fonts();
  }
  const fonts = () => document.fonts && ['400', '500', '600'].forEach((w) => document.fonts.load(w + ' 16px "DMP Nav"').catch(() => {}));
  const warm = () => HOVER.matches && eager();

  function show(d, pin) {
    clearTimeout(tOpen);
    clearTimeout(tClose);
    clearTimeout(d._t);
    aim = null;
    const cur = current();
    nav.classList.toggle('dmp-nav--instant', !!cur && cur !== d);
    all.forEach((x) => x !== d && x.open && hide(x, true));
    d.classList.remove('dmp-closing');
    d.open = true;
    d.dataset.pinned = pin ? '1' : '';
    sync(d);
    eager();
  }

  function hide(d, now) {
    clearTimeout(d._t);
    if (aim && aim.d === d) aim = null;
    d.dataset.pinned = '';
    if (now || RM.matches || !d.open) {
      d.classList.remove('dmp-closing');
      d.open = false;
      sync(d);
      return;
    }
    d.classList.add('dmp-closing');
    sync(d);
    d._t = setTimeout(() => {
      d.classList.remove('dmp-closing');
      d.open = false;
      sync(d);
    }, 120);
  }

  /* Bezpečná zóna pásu: pruh mezi lištou a pásem a trojúhelník od místa, kde
     ukazatel opustil položku, k hornímu okraji pásu (přes celou šířku). Dokud
     ukazatel míří k pásu, pás se nezavře. Zavře se 300 ms poté, co ukazatel
     není na položce, v pásu ani v zóně. */
  function inZone(x, y) {
    const a = aim;
    if (y > a.t) return false;
    if (y >= a.b) return true;
    if (y <= a.y) return false;
    const hit = a.x + ((x - a.x) * (a.t - a.y)) / (y - a.y);
    return hit >= 0 && hit <= root.clientWidth;
  }

  function closeLater(d) {
    clearTimeout(tClose);
    tClose = setTimeout(() => hide(d), 300);
  }

  function track(x, y) {
    if (inZone(x, y)) {
      if (aim.out) clearTimeout(tClose);
      aim.out = false;
    } else if (!aim.out) {
      aim.out = true;
      closeLater(aim.d);
    }
  }

  /* Záměr najetí: panel se otevře, až se ukazatel nad položkou zastaví (posun
     do 6 px). Čeká 120 ms, když je vše zavřené, 100 ms při přepnutí z jiného
     panelu a 180 ms z připnutého panelu (nový panel pak zůstane připnutý).
     Když je otevřený pás a ukazatel jede dolů k němu, sousední položka čeká 320 ms.
     Pouhý průjezd přes lištu tak nic neotevře. */
  function arm(d, x, y) {
    const cur = current();
    clearTimeout(tOpen);
    if (cur === d) return;
    const down = y - ly > 0;
    ax = x;
    ay = y;
    let wait = 120;
    if (cur) wait = cur.dataset.pinned ? 180 : 100;
    if (cur && down && cur.classList.contains('dmp-has-router')) wait = 320;
    tOpen = setTimeout(() => {
      const c = current();
      show(d, !!(c && c.dataset.pinned));
    }, wait);
  }

  function bind(d) {
    const s = d.firstElementChild;
    const c = s.nextElementSibling;
    s.setAttribute('role', 'button');
    if (c && c.id) s.setAttribute('aria-controls', c.id);
    sync(d);

    s.addEventListener('mouseenter', (e) => HOVER.matches && arm(d, e.clientX, e.clientY));
    s.addEventListener('mousemove', (e) => {
      if (!HOVER.matches || Math.abs(e.clientX - ax) + Math.abs(e.clientY - ay) < 6) return;
      arm(d, e.clientX, e.clientY);
    });
    s.addEventListener('mouseleave', () => clearTimeout(tOpen));
    d.addEventListener('mouseenter', () => {
      if (!HOVER.matches || !d.open) return;
      clearTimeout(tClose);
      aim = null;
      if (d.classList.contains('dmp-closing')) show(d, d.dataset.pinned === '1');
    });
    d.addEventListener('mouseleave', (e) => {
      if (!HOVER.matches) return;
      clearTimeout(tOpen);
      if (!d.open || d.dataset.pinned) return;
      aim = null;
      const t = d.classList.contains('dmp-has-router') ? c.getBoundingClientRect().top : 0;
      if (ly >= t) return closeLater(d);
      aim = { d, x: lx, y: ly, t, b: s.getBoundingClientRect().bottom, out: false };
      track(e.clientX, e.clientY);
    });
    s.addEventListener('click', (e) => {
      if (!DESK.matches) return;
      e.preventDefault();
      if (current() === d && d.dataset.pinned) hide(d, true);
      else show(d, true);
      setTimeout(() => sync(d));
    });
    d.addEventListener('toggle', () => {
      if (!d.open) {
        d.dataset.pinned = '';
        d.classList.remove('dmp-closing');
      }
      sync(d);
    });
  }

  function init() {
    setVw();
    nav = document.querySelector('.header__inline-menu');
    all = nav ? Array.from(nav.querySelectorAll('details')) : [];
    all.forEach((d) => {
      if (d.dataset.dmpInit) return;
      d.dataset.dmpInit = '1';
      bind(d);
    });
    if (nav && !nav.dataset.dmpInit) {
      nav.dataset.dmpInit = '1';
      /* Fotky a písmo panelů: na počítači s myší se stáhnou dřív, než se panel
         poprvé otevře (najetí na hlavičku, ukazatel v horní části okna, nebo
         chvíli po načtení stránky). Na mobilu se nestahují. */
      (nav.closest('.section-header') || nav).addEventListener('pointerenter', warm, { once: true });
      nav.addEventListener('focusin', eager, { once: true });
      const near = (e) => {
        if (e.clientY > 260) return;
        document.removeEventListener('mousemove', near);
        warm();
      };
      document.addEventListener('mousemove', near, { passive: true });
      const later = () => setTimeout(() => (window.requestIdleCallback || setTimeout)(warm), 2500);
      if (document.readyState === 'complete') later();
      else window.addEventListener('load', later, { once: true });
    }
  }

  document.addEventListener(
    'mousemove',
    (e) => {
      lx = e.clientX;
      ly = e.clientY;
      if (aim && !aim.d.contains(e.target)) track(lx, ly);
    },
    { passive: true }
  );
  root.addEventListener('mouseleave', () => aim && !aim.out && ((aim.out = true), closeLater(aim.d)));

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const d = current();
    if (!d) return;
    const inside = d.contains(document.activeElement);
    hide(d, true);
    if (inside) d.firstElementChild.focus();
  });

  document.addEventListener('click', (e) => {
    const d = current();
    if (d && !d.contains(e.target)) hide(d);

    const a = e.target.closest && e.target.closest('a[data-nav]');
    if (!a) return;
    const label = (a.querySelector('.dmp-router__title,.dmp-drawer-row__title,.header__cta-long') || a).textContent;
    (window.dataLayer = window.dataLayer || []).push({
      event: 'nav_click',
      nav_area: a.dataset.nav,
      nav_label: label.replace(/\s+/g, ' ').trim(),
      nav_url: a.getAttribute('href'),
    });

    const href = a.getAttribute('href') || '';
    const hd = a.closest('header-drawer');
    if (a.dataset.nav !== 'drawer_cta' || href.charAt(0) !== '#' || !hd) return;
    const target = document.getElementById(href.slice(1));
    if (!target) return;
    e.preventDefault();
    const sum = hd.querySelector('summary');
    hd.closeMenuDrawer(e, sum);
    sum.setAttribute('aria-expanded', 'false');
    setTimeout(() => {
      target.scrollIntoView({ behavior: RM.matches ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', href);
      /* Fokus (klávesnice, čtečka) přejde na nadpis formuláře, ne do pole,
         aby se na mobilu neotevřela klávesnice. */
      const sec = target.closest('section') || target.parentElement;
      const h = (sec && sec.querySelector('h2, h3')) || target;
      if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1');
      h.focus({ preventScroll: true });
    }, 420);
  });

  DESK.addEventListener('change', () => {
    if (!DESK.matches) all.forEach((d) => hide(d, true));
  });
  let raf;
  window.addEventListener('resize', () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(setVw);
  });

  document.addEventListener('pointerdown', (e) => e.target.closest && e.target.closest('header-drawer summary') && fonts());
  document.addEventListener('shopify:section:load', init);

  /* Editor: výběr bloku „Rozcestník v menu“ otevře panel (počítač),
     nebo menu v šuplíku se skupinou (mobil). */
  const blockOf = (e) => {
    const id = e.detail && e.detail.blockId;
    return id ? document.querySelectorAll('[data-dmp-block="' + id + '"]') : [];
  };
  let editorDrawer = false;
  document.addEventListener('shopify:block:select', (e) => {
    const els = Array.from(blockOf(e));
    if (!els.length) return;
    if (DESK.matches) {
      const d = els.map((el) => el.closest('.header__inline-menu details')).find(Boolean);
      if (d) show(d, true);
      return;
    }
    const g = els.find((el) => el.closest('header-drawer'));
    const hd = g && g.closest('header-drawer');
    if (!hd) return;
    const det = hd.querySelector('details');
    if (!det.open) {
      hd.querySelector('summary').click();
      editorDrawer = true;
    }
    setTimeout(() => g.scrollIntoView({ block: 'nearest' }), 450);
  });
  document.addEventListener('shopify:block:deselect', (e) => {
    const els = Array.from(blockOf(e));
    els.forEach((el) => {
      const d = el.closest('.header__inline-menu details');
      if (d) hide(d, true);
    });
    const hd = editorDrawer && document.querySelector('header-drawer');
    if (hd && hd.querySelector('details').open) hd.closeMenuDrawer(e, hd.querySelector('summary'));
    editorDrawer = false;
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
